import { HttpService, VisibaApiPromise, VisibaOptions } from '@services/http.service';
import { Singleton } from '@visiba/instantiation';
import { ParameterHandler } from '@visiba/std';
import { ApiBaseClient } from './_api_client_base';
import type { GuiComponentApiModel, UnitAboutApiModel, UnitConfigApiModel, UnitModel } from './generated/models';
import type { PublicBaseApiModel } from './models/PublicBaseApiModel';

@Singleton()
export class UnitsApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('units');
	}

	public async getTree(unitId: number): VisibaApiPromise<UnitModel> {
		return this.httpService.get(`${this.getBaseUri()}/${unitId}/tree`);
	}

	public async getUnitConfig(unitId: number, httpOptions?: VisibaOptions): VisibaApiPromise<UnitConfigApiModel> {
		return this.httpService.get(`${this.getBaseUri()}/${unitId}/config/web`, httpOptions);
	}

	public async getTexts<T extends string>(receptionId: number, keys: T[]): VisibaApiPromise<{ [K in T]: string | null }> {
		const parameterHandler = new ParameterHandler();
		parameterHandler.append({ aliases: keys.join(',') });

		return this.httpService.get(`${this.getBaseUri()}/${receptionId}/texts${parameterHandler.getString()}`);
	}

	public async getLicenseHolderAboutData(unitId: number): VisibaApiPromise<UnitAboutApiModel> {
		return this.httpService.get(`${this.getBaseUri()}/${unitId}/About`);
	}

	public async getData(unitId: number): VisibaApiPromise<NonNullable<UnitConfigApiModel['Offer']>> {
		const {
			data: { Offer },
		} = await this.httpService.get<UnitConfigApiModel>(`${this.getBaseUri()}/${unitId}/config/app`);

		if (Offer === null) throw new Error('Todo: should never be null');

		return {
			data: Offer,
			successful: true,
			headers: {},
		};
	}

	public async getUnitComponents(unitId: number): VisibaApiPromise<GuiComponentApiModel[]> {
		const url = `${this.getBaseUri()}/${unitId}/guicomponents`;

		return this.httpService.get(url);
	}

	public async getLicenseHolderData(alias: string): VisibaApiPromise<PublicBaseApiModel> {
		return this.httpService.get(`/general/licenceHolder/${alias}/publicBase`);
	}
}
